import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Modal, message } from "antd";

import { IUseFatca } from "./IUseFatca";
import { emptyFatca } from "../../Assets/Data/EmptyValues";
import { FatcaDTO } from "../../Models";

export const useFatca = ({
	translations,
	fatcaAPI,
	unlockNextStep,
	contractAPI
}: IUseFatca) => {
	const [searchParams, _] = useSearchParams();

	const [loading, setLoading] = useState<boolean>(false);
	const [fatcaData, setFatcaData] = useState<FatcaDTO>(emptyFatca);
	const [error, setError] = useState<boolean>(false);
	const [contractId, setContractId] = useState<number>(0);

	const radioStyle = {
		display: 'block',
		marginBottom:15,
		height: '30px',
		lineHeight: '30px',
	};
	
	useEffect(() => {
		if (searchParams.has('ContractId')) {
			configureInitialData(Number(searchParams.get('ContractId')));
		}
		 else if (searchParams.has('hash')) {
			const hash = searchParams.get('hash');
			const getContractIdByHash = async(hash: string) => {
				return await contractAPI.getContractByHash(hash).then((res: any) => {
					if (res.success) {
						configureInitialData(Number(res.data));
					} 
				})
			}
		
			getContractIdByHash(hash!);
		}
	}, [translations]);

	const configureInitialData = async(ContractId: number) => {
		setLoading(true);
		setContractId(ContractId);
		await fatcaAPI.getFatca(ContractId).then((res: any) => {
			if (res.success) {
				if(res.data){
					setFatcaData({...res.data, idContract: ContractId});
				}else{
					setFatcaData({...emptyFatca, idContract: ContractId});
				}
			}
			setLoading(false);
		})
		.catch((err: any) => {
			console.log(err);
		})
		setLoading(false);
	};

	const getInfo = (e: any) => {
		const key = e.target.dataset.key;
		Modal.info({
			content: (
				<div>
					{translations[`tooltipFatca${key ? key : ''}`]}
				</div>
			),
			onOk() { },
		});
	};

	const postFatca = async() => {
		await fatcaAPI.saveFatca(fatcaData).then((res: any) => {
			if (res.success) {
				message.success(translations.datosGuardados);
				unlockNextStep(contractId);
				setLoading(false);
			}else{
				message.error(translations.errorGuardado);
				setLoading(false);
			}
		}
		).catch((err: any) => {
			console.log(err);
			message.error(translations.errorGuardado);
			setLoading(false)
		});
	}

	const updateFatca = async() => {
		await fatcaAPI.updateFatca(fatcaData).then((res: any) => {
			if (res.success) {
				message.success(translations.datosGuardados);
				setLoading(false);
			}else{
				message.error(translations.errorGuardado);
				setLoading(false);
			}
		}
		).catch((err: any) => {
			console.log(err);
			message.error(translations.errorGuardado);
			setLoading(false)
		}
		)
	}

	const saveData = async() => {
		setLoading(true);
		if (!fatcaData.option) {
			setError(true);
		} else {
			if (fatcaData.id === 0) {
				await postFatca();
			}
			else if (fatcaData.id > 0) {
				await updateFatca();
			}
		}
		setLoading(false);
	};

	const handleChangeData = (e: any) => {
		const { name, value } = e.target;
		if(value !== 9){
			setFatcaData((prevState: FatcaDTO) => ({
				...prevState,
				otherText: '',
				[name]: value
			}));
		}
		else{
			setFatcaData((prevState: FatcaDTO) => ({
				...prevState,
				[name]: value
			}));
		}
	};

	return {
		loading,
		fatcaData,
		radioStyle,
		error,
		contractId,
		getInfo,
		handleChangeData,
		saveData,
	};
};